import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import '@SDCss';
import { isOverseas } from '@moka-fe/ats.utils';
import cms from '@moka-fe/cms';
import classNames from 'classnames';
import {
  Button,
  Checkbox,
  Dropdown,
  Form,
  Icon,
  Input,
  Menu,
  Spacing,
  Tooltip,
} from 'sugar-design';
import * as sdf from '@SDFoundation';

import SecretModal from '@/components/common/SecretModal';

import { ACCOUNT_TYPES, LOCALES_LABEL, LOGIN_PANEL_TYPES, isDingtalk } from '@/constants/common';
import { deleteMe } from '@/redux/actions/me';
import { emailValidator, smsCodeValidator } from '@/utils/common';
import {
  HEADHUNTER_LOCALE_SESSION_STORAGE_KEY,
  LOCALES,
  getHeadhunterDefaultLoginLocale,
  getI18n,
} from '@/utils/i18n';

import styles from './index.cm.styl';
import pointLeftSvg from '@/static/images/login/pointLeft.svg';
import warnSvg from '@/static/images/login/warn.svg';

const i18n = getI18n(getHeadhunterDefaultLoginLocale());

// 海外版O无汉字版验证码cid 请勿修改
const OVERSEAS_CAPTCHA_ID = '6ea32bcad4a741f6b871a3ffd3187d4f';

// onKeyDown时，如果按下的是指定按键，则执行callback
function whenKeyIs(key, callback) {
  return (event) => {
    if (event.key === key) {
      return callback(event);
    }
  };
}

class LoginModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: {
        email: '',
        password: '',
        captcha: '',
        smsCode: '',
      },
      backToLogin: false, // 标示是否是返回登录页面。
      email: props.email,
      password: props.password,
      refreshCaptcha: false,
      showErrorDiv: true,
      message: '',
      mobileShowErrorMessage: false, // 用于控制动画
      orgId: null,
      isMFA: props.isMFA,
      smsCode: '', // 短信验证码，需要用户手动输入
      // eslint-disable-next-line react/no-unused-state
      smsLogin: '', // 输入的内容
      reclaimBlockCounter: props.reclaimCounter || 60, // 要求重新发送验证码的计时器
      showSecretModal: false,
      agreePrivacyPolicy: false,
    };
    this.onChange = this.onChange.bind(this);
    this.submitUserPassword = this.submitUserPassword.bind(this);
    this.submitSMS = this.submitSMS.bind(this);
    this.submitWithOrgId = this.submitWithOrgId.bind(this);
    this.onForceLogin = this.onForceLogin.bind(this);
    this.renderErrorMessage = this.renderErrorMessage.bind(this);
    this.renderCaptcha = this.renderCaptcha.bind(this);
    this.renderUserPasswordLoginPanel = this.renderUserPasswordLoginPanel.bind(this);
    this.renderAccountForbiddenPanel = this.renderAccountForbiddenPanel.bind(this);
    this.renderChooseOrgPanel = this.renderChooseOrgPanel.bind(this);
    this.renderSMSLoginPanel = this.renderSMSLoginPanel.bind(this);
    this.renderPanel = this.renderPanel.bind(this);
    this.validatePassword = this.validatePassword.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.validateSMSCode = this.validateSMSCode.bind(this);
    this.backToLoginPanel = this.backToLoginPanel.bind(this);
    this.reclaimSMSCode = this.reclaimSMSCode.bind(this);
    this.reclaimText = this.reclaimText.bind(this);
    this.onEnterPress = this.onEnterPress.bind(this);
    // 和refs类似的东西
    this.elements = {};
    // ref函数
    this.refCaptcha = this.createRefFunc.call(this, 'captcha');
    this.refForm = this.createRefFunc.call(this, 'form');
    this.onFormEnter = whenKeyIs('Enter', this.onEnterPress.bind(this));
    this.initCaptcha = this.initCaptcha.bind(this);
    this.errorMessageTimer = null;

    setInterval(() => {
      if (this.state.reclaimBlockCounter > 0) {
        this.setState({
          reclaimBlockCounter: this.state.reclaimBlockCounter - 1,
        });
      }
    }, 1000);
  }

  onEnterPress() {
    return this.state.isMFA ? this.submitSMS() : this.submitUserPassword();
  }

  submitWithOrgId(orgId) {
    return () => {
      this.setState({ orgId }, () => {
        return this.submitUserPassword();
      });
    };
  }

  reclaimText() {
    return this.state.reclaimBlockCounter > 0
      ? i18n.t`重新发送(${this.state.reclaimBlockCounter})`
      : i18n.t`重新发送`;
  }

  componentWillUnmount() {
    if (this.errorMessageTimer) {
      clearTimeout(this.errorMessageTimer);
      this.errorMessageTimer = null;
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      isMFA: nextProps.isMFA,
      reclaimBlockCounter: nextProps.reclaimCounter,
    });

    // 这里删除了一段移动端显示错误的代码，按道理，猎头端没有移动端才对

    if (nextProps.message && nextProps.showError && !nextProps.needCaptcha) {
      this.setErrorMessage(nextProps.message);
    }
  }

  setErrorMessage = (message) => {
    if (this.errorMessageTimer) {
      clearTimeout(this.errorMessageTimer);
      this.errorMessageTimer = null;
    }
    this.setState(
      {
        mobileShowErrorMessage: true,
        message,
      },
      () => {
        this.errorMessageTimer = setTimeout(() => {
          this.setState({
            mobileShowErrorMessage: false,
            message: '',
          });
        }, 2000);
      }
    );
  };

  setMobileErrorMessage(message) {
    if (this.errorMessageTimer) {
      clearTimeout(this.errorMessageTimer);
      this.errorMessageTimer = null;
    }
    this.setState(
      {
        mobileShowErrorMessage: true,
        message,
      },
      () => {
        this.errorMessageTimer = setTimeout(() => {
          this.setState({
            mobileShowErrorMessage: false,
            message: '',
          });
        }, 2000);
      }
    );
  }

  submitUserPassword() {
    if (!this.validateEmail()) {
      return false;
    }
    if (!this.validatePassword()) {
      return false;
    }
    if (this.props.needCaptcha && !this.props.needForceKey) {
      return false;
    }
    if (!this.state.agreePrivacyPolicy) {
      return false;
    }
    this.setState({ backToLogin: false, showErrorDiv: false });
    const { onSubmit, needForceKey } = this.props;
    const { email, password, orgId } = this.state;
    const pending = {
      email: email,
      password: password,
      forceLoginKey: needForceKey,
      orgId: orgId,
    };
    return onSubmit(pending);
  }

  reclaimSMSCode() {
    this.setState({
      reclaimBlockCounter: 60,
    });
    const { onReclaimSMSCode, smsTempKey } = this.props;
    const { email } = this.state;
    const pending = {
      email: email,
      smsTempKey: smsTempKey,
    };
    return onReclaimSMSCode(pending);
  }

  submitSMS() {
    if (!this.validateSMSCode()) {
      this.setError('smsCode', i18n.t`验证码格式错误，请重试`);
      return false;
    }
    if (this.props.needCaptcha) {
      return false;
    }
    this.setState({ backToLogin: false, showErrorDiv: false });
    const { onSubmitSMSCode, needForceKey, smsTempKey } = this.props;
    const { email, password, orgId, smsCode } = this.state;
    const pending = {
      email: email,
      password: password,
      forceLoginKey: needForceKey,
      orgId: orgId,
      smsTempKey: smsTempKey,
      smsCode: smsCode,
    };
    return onSubmitSMSCode(pending);
  }

  onForceLogin() {
    return this.submitUserPassword();
  }

  // 设置错误信息
  setError(key, message) {
    this.setState({
      error: {
        ...this.state.error,
        [key]: message,
      },
    });
    if (message && this.props.isMobile) {
      this.setMobileErrorMessage(message);
    }
  }

  delError(key) {
    return this.setError(key, '');
  }

  // 验证邮箱
  validateEmail() {
    if (!emailValidator(this.state.email)) {
      this.setError('email', i18n.t`请输入正确的邮箱`);
      return false;
    } else {
      this.delError('email');
      return true;
    }
  }

  validateSMSCode() {
    if (!smsCodeValidator(this.state.smsCode)) {
      this.setError('smsCode', i18n.t`请输入正确的短信验证码`);
      return false;
    }
    this.delError('smsCode');
    return true;
  }

  // 验证密码
  validatePassword() {
    if (!this.state.password || !this.state.password.length) {
      this.setError('password', i18n.t`请输入正确的密码`);
      return false;
    } else {
      this.delError('password');
      return true;
    }
  }

  // 更新表单数据
  onChange({ target: { name, value } }) {
    this.setState({ [name]: value });
  }

  initCaptcha() {
    const { isMobile } = this.props;
    const { backToLogin } = this.state;
    const { forbiddenTime, needForceKey, needCaptcha, captchaId } = this.props;
    // 海外版使用无汉字版验证码
    const realCID = isOverseas ? OVERSEAS_CAPTCHA_ID : captchaId;
    if (needCaptcha && (backToLogin || (!forbiddenTime && !needForceKey))) {
      if (window.initNECaptcha) {
        window.initNECaptcha(
          {
            // config对象，参数配置
            captchaId: realCID,
            element: this.elements.captcha,
            mode: 'float',
            width: isMobile ? 'auto' : 400,
            lang: i18n.language === LOCALES.EN_US ? 'en' : 'zh-CN',
            onVerify: (err, data) => {
              if (!err) {
                this.delError('captcha');
                return this.props.setNECaptchaValidate(data.validate);
              }
            },
          },
          () => {},
          () => {
            // console.log(err);
          }
        );
      } else {
        this.setError('captcha', i18n.t`验证码加载失败，请刷新页面`);
      }
    }
  }

  componentDidMount() {
    if (this.props.message) {
      this.setMobileErrorMessage(this.props.message);
    }
  }

  componentDidUpdate(prevProps, prevStates) {
    // 更改了一下这里：从this.props.wrongPasswordTimes == prevProps.wrongPasswordTime + 1
    // 改成了只要wrongPasswordTimes比之前的大就会触发
    if (this.props.wrongPasswordTimes > prevProps.wrongPasswordTimes) {
      // 为了刷新动画的特殊处理，删除元素再添加元素。
      this.setState({ showErrorDiv: true });
    }
    if (
      (!prevProps.needCaptcha && this.props.needCaptcha) ||
      (this.props.needCaptcha && prevProps.captchaTime !== this.props.captchaTime)
    ) {
      this.setError('captcha', i18n.t`请进行验证`);
      this.initCaptcha();
    }
    if (this.state.backToLogin && !prevStates.refreshCaptcha && this.state.refreshCaptcha) {
      this.setError('captcha', i18n.t`请进行验证`);
      this.initCaptcha();
      this.setState({ refreshCaptcha: false });
    }
  }

  renderCaptcha() {
    if (this.props.needCaptcha) {
      const { error } = this.state;
      return (
        <div className={classNames('form-item', { error: error.captcha.length })}>
          <div ref={this.refCaptcha} />
          <span className="error-msg">{error.captcha}</span>
        </div>
      );
    }
  }

  // 生成ref函数
  createRefFunc(name) {
    return (element) => {
      this.elements[name] = element;
    };
  }

  // 返回的时候需要把smsCodes给清空
  // 返回后清空 forbiddenTime
  backToLoginPanel() {
    this.props.setNECaptchaValidate('');
    this.props.deleteMe();
    this.setState({
      backToLogin: true,
      email: '',
      password: '',
      refreshCaptcha: true,
      smsCode: '',
      message: '',
      isMFA: false,
    });
  }

  onShowSecretModal = () => {
    this.setState({ showSecretModal: true });
  };
  onHideSecretModal = () => {
    this.setState({ showSecretModal: false });
  };

  renderErrorMessage() {
    const { showErrorDiv, mobileShowErrorMessage, message = '', isMFA = false } = this.state;
    const { wrongPasswordTimes = 0, showError, needCaptcha, isMobile = false } = this.props;

    if (isMobile) {
      if (message && mobileShowErrorMessage) {
        return (
          <span className="message error-msg">
            <span>{message}</span>
          </span>
        );
      }
      return null;
    }
    if (isMFA) {
      return message ? (
        <div className={styles.errorDiv}>
          <Icon name="unassess" className={styles.errorIcon} />
          <span>{message}</span>
        </div>
      ) : null;
    }
    if (showErrorDiv && wrongPasswordTimes >= 5) {
      return (
        <div className={styles.errorDiv}>
          <Icon name="unassess" className={styles.errorIcon} />
          <span>{i18n.t`账号或密码尝试次数过多，您还有${10 - wrongPasswordTimes}次尝试机会`}</span>
        </div>
      );
    }
    if (message.length === 0) {
      return null;
    }

    // 必须有图形验证
    if (!needCaptcha && showError) {
      return (
        <div className={styles.errorDiv}>
          <Icon name="unassess" className={styles.errorIcon} />
          <span>{message}</span>
        </div>
      );
    }
  }

  onChangeLocale = (locale) => {
    return () => {
      localStorage.setItem(HEADHUNTER_LOCALE_SESSION_STORAGE_KEY, locale);
      window.location.reload();
    };
  };

  onDingTalkLogin = () => {
    const { origin } = window.location;
    window.location.href = `${origin}/eco/cert/landing?ecologyType=2&agentType=14&targetPath=%2Fapi%2Fheadhunters%2Fv2%2Flogin_dt`;
  };

  renderUserPasswordLoginPanel() {
    const { email, password, error, showSecretModal, agreePrivacyPolicy } = this.state;
    const { accountType, hiddenTitle, loginButtonName } = this.props;
    const defaultLocale = getHeadhunterDefaultLoginLocale();

    return (
      <div className="login-modal-panel">
        <Spacing stretched justify="between">
          {!hiddenTitle && (
            <div className="title">
              {accountType === ACCOUNT_TYPES.HEADHUNTER ? i18n.t`猎头` : i18n.t`登录到您的账户`}
            </div>
          )}
          <Dropdown
            showArrow
            triggerType="hover"
            wrapperClassName={styles.localWrapper}
            popupStretched
            popup={
              <Menu>
                {[LOCALES.ZH_CN, LOCALES.EN_US].map((value) => (
                  <Menu.Item
                    key={value}
                    className={styles.localItem}
                    isActive={defaultLocale === value}
                    onClick={this.onChangeLocale(value)}
                  >
                    {LOCALES_LABEL[value]}
                  </Menu.Item>
                ))}
              </Menu>
            }
          >
            <Spacing>
              <Icon name="website" noTop />
              {i18n.t`msg.LOGIN_LANGUAGE`} - {LOCALES_LABEL[defaultLocale]}
              <Icon name="down" noTop />
            </Spacing>
          </Dropdown>
        </Spacing>

        <div className={styles.subTitle}>{i18n.t`欢迎登录`}</div>
        {this.renderErrorMessage()}
        <form
          method="post"
          ref={this.refForm}
          onKeyDown={this.onFormEnter}
          onSubmit={(e) => e.preventDefault()}
        >
          <Form.Item message={error.email} spacing="md">
            <Input
              type="email"
              name="email"
              value={email}
              onBlur={this.validateEmail}
              onChange={this.onChange}
              placeholder={i18n.t`请输入账号`}
            />
          </Form.Item>

          <Form.Item message={error.password} spacing="md">
            <Input
              type="password"
              name="password"
              value={password}
              onBlur={this.validatePassword}
              onChange={this.onChange}
              placeholder={i18n.t`请输入密码`}
            />
          </Form.Item>

          {this.renderCaptcha()}

          <Tooltip
            wrapperClassName={styles.privacyTooltip}
            disabled={agreePrivacyPolicy}
            content={i18n.t`请先勾选隐私政策`}
            placement="top"
          >
            <Button
              className={classNames(cms['mgy-16'])}
              stretched
              onClick={this.submitUserPassword}
            >
              {loginButtonName || i18n.t`登录`}
            </Button>
          </Tooltip>
        </form>
        <div className="secret-box">
          <Checkbox onChange={(e) => this.setState({ agreePrivacyPolicy: e.target.checked })}>
            <div>
              {i18n.t`我已阅读并同意`}
              <span className={sdf.b50} onClick={this.onShowSecretModal}>
                {i18n.t`《Moka隐私政策》`}
              </span>
            </div>
          </Checkbox>
          <a
            className={classNames('forget-password', styles.forgotPassword)}
            href={
              accountType === ACCOUNT_TYPES.HEADHUNTER
                ? '/headhunters/forget_password'
                : '/forget_password'
            }
          >
            {i18n.t`忘记密码`}
          </a>
        </div>
        {showSecretModal && (
          <SecretModal
            locale={i18n.language}
            className="secret-modal"
            onClose={this.onHideSecretModal}
          />
        )}
      </div>
    );
  }

  renderSMSLoginPanel() {
    const { error, smsCode } = this.state;
    const { phone } = this.props;
    const reclaimDisabled = this.state.reclaimBlockCounter > 0;
    const msgBox = this.renderErrorMessage() || (
      <div className="sub_title">{i18n.t`短信验证码已发送至 +86 ${phone} 请注意查收，若手机号码有误请联系公司管理员`}</div>
    );
    return (
      <div className="sms_login_panel">
        <div className="title">
          <a onClick={this.backToLoginPanel}>
            <img src={pointLeftSvg} />
          </a>
          {i18n.t`请输入短信验证码`}
        </div>
        <div className="grey-line"> </div>
        {msgBox}
        <form
          method="post"
          ref={this.refForm}
          onKeyDown={this.onFormEnter}
          onSubmit={(e) => e.preventDefault()}
        >
          <div className={classNames('form-item', { error: error.smsCode.length })}>
            <div>
              <input
                type="text"
                name="smsCode"
                className="smsInput"
                value={smsCode}
                onChange={this.onChange}
                placeholder={i18n.t`请输入验证码`}
              />
            </div>
            <div>
              <button
                type="button"
                disabled={reclaimDisabled}
                className="reclaim-btn"
                onClick={this.reclaimSMSCode}
              >
                {this.reclaimText()}
              </button>
            </div>
            <span className="error-msg">{error.smsCode}</span>
          </div>
          {this.renderCaptcha()}
          <div className={classNames('form-item')}>
            <button
              type="button"
              className="submit"
              onClick={this.submitSMS}
            >{i18n.t`登录`}</button>
          </div>
        </form>
      </div>
    );
  }

  renderForceLoginPanel() {
    const { hiddenTitle } = this.props;
    return (
      <div className="force_login_panel">
        <div className="title">
          <a onClick={this.backToLoginPanel}>
            <img src={pointLeftSvg} />
          </a>
          {hiddenTitle ? '' : i18n.t`登录信息提示`}
        </div>
        {!hiddenTitle && <div className="grey-line"> </div>}
        <img className="warn" src={warnSvg} />
        <div className="sub_title">{i18n.t`系统检测到您使用的账号已登录`}</div>
        <div className="description">{i18n.t`点击“确认”继续登录Moka，登录成功会让已登录的用户下线，可能导致已登录此账号的其他用户丢失尚未保存的内容`}</div>
        <input type="button" value={i18n.t`确认`} className="submit" onClick={this.onForceLogin} />
      </div>
    );
  }

  renderAccountForbiddenPanel() {
    const { forbiddenTime, hiddenTitle } = this.props;
    return (
      <div className="force_login_panel">
        <div className="title">
          <a onClick={this.backToLoginPanel}>
            <img src={pointLeftSvg} />
          </a>
          {hiddenTitle ? '' : i18n.t`登录信息提示`}
        </div>
        {!hiddenTitle && <div className="grey-line"> </div>}
        <img className="warn" src={warnSvg} />
        <div className="sub_title">{i18n.t`账号登录异常`}</div>
        <div className="description">{i18n.t`亲爱的用户：Moka安全中心检测到账号存在异常行为,出于安全考虑，账号将从${forbiddenTime}起被锁定1小时`}</div>
        <div className="submit" onClick={this.backToLoginPanel}>{i18n.t`确认`}</div>
      </div>
    );
  }

  renderChooseOrgPanel() {
    const { validOrgs, hiddenTitle } = this.props;
    return (
      <div className="choose_orgs_login_panel">
        <div className="title">
          <a onClick={this.backToLoginPanel}>
            <img src={pointLeftSvg} />
          </a>
          {hiddenTitle ? '' : i18n.t`选择您要登录的公司`}
        </div>
        {!hiddenTitle && <div className="grey-line"> </div>}
        <div>
          {validOrgs.map((validOrg, index) => {
            let nameClass = 'choose_org_display_name ';
            if (!validOrg.displayName) {
              nameClass += 'middle-name';
            }
            return (
              <div
                className="choose_org_item"
                onClick={this.submitWithOrgId(validOrg.orgId)}
                key={'org-item' + index}
              >
                <div className="choose_org_logo">
                  {validOrg.logo ? (
                    <img src={validOrg.logo} />
                  ) : (
                    <span className="text-avatar">{validOrg.name.slice(0, 2)}</span>
                  )}
                </div>
                <div className="choose_org_name">
                  <div className={nameClass}>{validOrg.name}</div>
                  <div className="choose_org_id">{validOrg.displayName || ''}</div>
                </div>
                <div className="choose_org_icon">
                  <Icon name="right" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  renderDTLoginPanel = () => {
    const { showSecretModal, agreePrivacyPolicy } = this.state;
    const defaultLocale = getHeadhunterDefaultLoginLocale();
    return (
      <div className="login-modal-panel">
        <Spacing stretched justify="between">
          <div className="title">{i18n.t`猎头`}</div>
          <Dropdown
            showArrow
            triggerType="hover"
            wrapperClassName={styles.localWrapper}
            popupStretched
            popup={
              <Menu>
                {[LOCALES.ZH_CN, LOCALES.EN_US].map((value) => (
                  <Menu.Item
                    key={value}
                    className={styles.localItem}
                    isActive={defaultLocale === value}
                    onClick={this.onChangeLocale(value)}
                  >
                    {LOCALES_LABEL[value]}
                  </Menu.Item>
                ))}
              </Menu>
            }
          >
            <Spacing>
              <Icon name="website" noTop />
              {i18n.t`msg.LOGIN_LANGUAGE`} - {LOCALES_LABEL[defaultLocale]}
              <Icon name="down" noTop />
            </Spacing>
          </Dropdown>
        </Spacing>

        <Spacing className={cms.mgy32} stretched direction="vertical" justify="center" spacing={24}>
          <div>{i18n.t`欢迎使用钉钉安全登录`}</div>
          <Tooltip disabled={agreePrivacyPolicy} content={i18n.t`请先勾选隐私政策`} placement="top">
            <Button
              stretched
              icon="dingding"
              disabled={!agreePrivacyPolicy}
              onClick={this.onDingTalkLogin}
            >
              {i18n.t`登录`}
            </Button>
          </Tooltip>
        </Spacing>
        <div className="secret-box">
          <Checkbox onChange={(e) => this.setState({ agreePrivacyPolicy: e.target.checked })}>
            <div>
              {i18n.t`我已阅读并同意`}
              <span className={sdf.b50} onClick={this.onShowSecretModal}>
                {i18n.t`《Moka隐私政策》`}
              </span>
            </div>
          </Checkbox>
        </div>
        {showSecretModal && (
          <SecretModal
            locale={i18n.language}
            className="secret-modal"
            onClose={this.onHideSecretModal}
          />
        )}
      </div>
    );
  };

  renderPanel() {
    const { backToLogin, isMFA } = this.state;
    const { forbiddenTime, needForceKey, validOrgs } = this.props;
    let loginPanelType = LOGIN_PANEL_TYPES.login;
    if (!backToLogin) {
      if (forbiddenTime) {
        loginPanelType = LOGIN_PANEL_TYPES.accountForbidden;
      } else if (isMFA) {
        loginPanelType = LOGIN_PANEL_TYPES.smsLogin;
      } else if (needForceKey) {
        loginPanelType = LOGIN_PANEL_TYPES.forceLogin;
      } else if (validOrgs && validOrgs.length && validOrgs.length > 1) {
        loginPanelType = LOGIN_PANEL_TYPES.chooseOrgLogin;
      } else if (isDingtalk) {
        loginPanelType = LOGIN_PANEL_TYPES.dtLogin;
      }
    }
    switch (loginPanelType) {
      case LOGIN_PANEL_TYPES.forceLogin:
        return this.renderForceLoginPanel();
      case LOGIN_PANEL_TYPES.accountForbidden:
        return this.renderAccountForbiddenPanel();
      case LOGIN_PANEL_TYPES.chooseOrgLogin:
        return this.renderChooseOrgPanel();
      case LOGIN_PANEL_TYPES.smsLogin:
        return this.renderSMSLoginPanel();
      case LOGIN_PANEL_TYPES.dtLogin:
        return this.renderDTLoginPanel();
      default:
        return this.renderUserPasswordLoginPanel();
    }
  }

  render() {
    return <div className="login-modal">{this.renderPanel()}</div>;
  }
}

LoginModal.defaultProps = {
  email: '',
  password: '',
  needCaptcha: false,
};

LoginModal.propTypes = {
  email: PropTypes.string, // 初始邮箱
  password: PropTypes.string, // 初始密码
  needCaptcha: PropTypes.bool, // 是否需要验证
  needForceKey: PropTypes.string, // 强制登录key
  message: PropTypes.string, // 提示信息
  captchaId: PropTypes.string, // 验证场景Id
  captchaTime: PropTypes.number, // 用于动态刷新Captcha
  forbiddenTime: PropTypes.string, // 账号被禁用的时间。
  wrongPasswordTimes: PropTypes.number, // 密码错误的次数。
  accountType: PropTypes.string, // 账号类型，暂时只有user和headhunter两种。
  onSubmit: PropTypes.func.isRequired, // 提交账号密码登录
  onSubmitSMSCode: PropTypes.func.isRequired, // 提交短信验证码登录
  onReclaimSMSCode: PropTypes.func.isRequired, // 要求重新发送短信验证码
  setNECaptchaValidate: PropTypes.func,
  isMobile: PropTypes.bool.isRequired,
  validOrgs: PropTypes.array, // 可选的 orgs.
  hiddenTitle: PropTypes.bool, // 是否需要title
  loginButtonName: PropTypes.string, // 登录按钮名字
  phone: PropTypes.string, // 电话号码
  smsTempKey: PropTypes.string, // 用于验证的临时key
  isMFA: PropTypes.bool, // 标记是否进入MFA登录页面
  showError: PropTypes.bool, // 是否展示错误信息
};

export default connect(
  (state) => {
    return {
      captchaId: state.applications.captchaId,
    };
  },
  {
    deleteMe,
  }
)(LoginModal);
